import {getAuth, signInWithPopup, signInWithRedirect, GoogleAuthProvider, onAuthStateChanged, signOut} from "firebase/auth";
import {app} from "./firebaseModel.js"

const auth = getAuth(app);
const provider = new GoogleAuthProvider();
var uid = null;

// onAuthStateChanged(auth, loginOrOutACB);

// function loginOrOutACB(user){
//     //model.setUserID(user?.uid)
//     uid = user?.uid;
// }

function loginClickHandler(){
    auth.currentUser? signOut(auth) : signInWithPopup(auth, provider)
}

function getUid(){
    return uid;
}

export {loginClickHandler, getUid, auth }
